import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import BSUPatientHeader from "./BSUPatientHeader";

const DrawerStackComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Stack"} />
            <CMRSliderComponent type={SliderType.Stack} title={"Rotate"} />
            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"bsu"}
                payload={"BSU"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.BSUObject} />
        </>
    );
};

export default DrawerStackComponent;
